/**
 * Stripe API Key (Publishable Key)
 */
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_JUDGEFEST_STRIPE_PUBLISHABLE_KEY || ""

/**
 * Sentry DSN Key
 */
export const SENTRY_DSN = "https://9459879afd6546f4966f140843891164@o370480.ingest.sentry.io/5519223"
